import { getFormattedValue } from '../../../../../../../features/formatters'
import {
  AD_TEXT,
  FB_PAGE_CHOICE,
  FORMAT_OPTION,
  FORMAT_SINGLE,
  PRIMARY_TEXT_LIST
} from '../../../../../../../forms/Facebook/AdForms/fields'
import { FILE_URL, MEDIA_TYPE } from '../../../../../../../forms/ReusableFormFields/AdFileUpload/fields'

export const getFormattedFacebookSocialPostData = (post = {}, facebookPageData = {}) => {
  const videoUrl = post.source
  const imageUrl = post['full_picture']
  const fileUrl = videoUrl || imageUrl

  const mediaType = !!videoUrl ? 'video' : 'image'

  return {
    ...post,
    impressions: getFormattedValue({ value: post['post_impressions'] }),
    reach: getFormattedValue({ value: post['post_impressions_unique'] }),
    frequency: getFormattedValue({
      value: post['post_impressions'] / post['post_impressions_unique'],
      type: 'frequency'
    }),
    clicks: getFormattedValue({ value: post['post_clicks'] }),
    ctr: getFormattedValue({
      value: post['post_clicks'] / post['post_impressions'],
      type: 'ctr'
    }),
    reactions: getFormattedValue({ value: post['post_reactions_by_type_total'] }),
    shares: getFormattedValue({ value: post['shares'] }),
    videoViews: getFormattedValue({ value: post['post_video_views'] }),
    // preview transformation
    [AD_TEXT]: post.message,
    [FB_PAGE_CHOICE]: facebookPageData['external_id'],
    [FORMAT_OPTION]: FORMAT_SINGLE,
    [PRIMARY_TEXT_LIST]: [{ text: post.message }],
    [FILE_URL]: fileUrl,
    [MEDIA_TYPE]: mediaType
  }
}
